export interface AdminUserSearchDto {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  roles?: string[];
  canViewDevicePasswords?: boolean;
  smsEnabled?: boolean;
}

export interface AdminUsersSearched {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  totalRows?: number;
  rows?: AdminUserSearchDto[];
}

export interface AdminUserForm {
  email?: string;
  firstName?: string;
  lastName?: string;
  roles?: string[];
}

export interface AdminUserCrudded {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  user?: AdminUserDetails;
}

export interface AdminUserDetails {
  id?: string;
  email?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  roles?: string[];
  lockedOut?: boolean;
}

export interface AdminUserCrudded {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
}

export interface UserInfoDto {
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
}

export enum Roles {
  Monitoring = 'Monitoring',
  SuperAdmin = 'SuperAdmin',
  User = 'User',
  IntegratorAdmin = 'IntegratorAdmin',
  ProjectAdmin = 'ProjectAdmin',
  SalesPerson = 'SalesPerson',
  Installer = 'Installer',
  CompanyAdmin = 'CompanyAdmin',
}

export type RoleCategory = 'monitoring' | 'admin' | 'watchfulGo';

export interface RoleDisplayInfo {
  label: string;
  description: string;
  category: RoleCategory;
}

export const ROLE_DISPLAY: Record<Roles, RoleDisplayInfo> = {
  [Roles.Monitoring]: { label: 'Monitoring', description: 'Access to the monitoring portal for alert handling', category: 'monitoring' },
  [Roles.SuperAdmin]: { label: 'Super Admin', description: 'Full system access including all portals and Watchful Go', category: 'admin' },
  [Roles.IntegratorAdmin]: { label: 'System Admin', description: 'System-level admin access with full Watchful Go access', category: 'admin' },
  [Roles.Installer]: { label: 'Installer', description: 'Installer access', category: 'admin' },
  [Roles.SalesPerson]: { label: 'Sales Person', description: 'Sales access', category: 'admin' },
  [Roles.ProjectAdmin]: { label: 'Watchful Go - Site Admin', description: 'See assigned sites, arm/disarm, manage schedules, view past alerts', category: 'watchfulGo' },
  [Roles.CompanyAdmin]: { label: 'Watchful Go - Company Admin', description: 'Full company access including user/site/device management', category: 'watchfulGo' },
  [Roles.User]: { label: 'Watchful Go - Basic User', description: 'Access to app to arm/disarm monitoring', category: 'watchfulGo' },
};

export const CATEGORY_CONFIG: Record<RoleCategory, { bg: string; text: string }> = {
  monitoring: { bg: 'bg-blue-500/10', text: 'text-blue-400' },
  admin: { bg: 'bg-purple-500/10', text: 'text-purple-400' },
  watchfulGo: { bg: 'bg-green-500/10', text: 'text-green-400' },
};
